import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../type/Shared'
import { Button, Card, CardActions, CardContent, CardMedia, Grid, Typography } from '@mui/material'
import BoldIconButton from '../styles/Component/BoldIconButton'
import FavoriteBorderSharpIcon from "@mui/icons-material/FavoriteBorderSharp";
import { AddShoppingCart, Delete, Edit } from '@mui/icons-material';
import { Link } from 'react-router-dom';

export interface Category {
    id: string
    name: string
    image: string
  }
  
  export interface Product {
    id: string
    name: string 
    price: number
    description: string 
    category: Category
    inventory: number
    images: string[]
  }
  
  export interface User {
    id: string
    firstName: string
    lastName: string
    email: string 
    role: string
  }
  
  export interface Category {
    id: string
    name: string
    image: string
  }

const TestComponents = () => {
    const [categories, setCategories] = useState<Category[]>([]);
    const [products, setProducts] = useState<Product[]>([]);

    const getCategories = async (): Promise<void> => {
        try {
            const response = await fetch(`https://shop-waves-backend.azurewebsites.net/api/v1/categories`);
            // const response = await fetch("https://api.escuelajs.co/api/v1/categories");
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data: Category[] = await response.json();
            setCategories(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getCategories();
    }, []);
  return (
    <div>
    <h2>products</h2>
    <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
        // display="flex"
        // flexWrap="wrap"
        padding={6}
      >
        {categories.map((product) => (
          <Grid item key={product.id} xs={8} sm={4} md={4} lg={2}>
            <Card
              // sx={{ width: 300, height: "100%" }}
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <CardMedia
                component="img"
                sx={{ height: 300, backgroundSize: "contain" }}
                image={product.image}
                title={product.name}
              />
              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <Link to={`/categories/${product.id}`}>
                <Button 
                  variant="contained"
                  color="success"
                  sx={{ 
                    borderRadius: 5, 
                    boxShadow: 3,
                    transition: "opacity 1.3s",
                    "&:hover": {
                      opacity: 1.7, 
                    }, 
                  }}
                >
                  SHOP NOW
                </Button>
                </Link>
              </CardContent>
              <CardActions
                style={{ justifyContent: "space-between", marginTop: "auto" }}
              >
                <BoldIconButton aria-label="add to favorites" bold>
                  <Delete />
                </BoldIconButton>
            
                <BoldIconButton aria-label="add to cart" bold>
                  <Edit/>
                </BoldIconButton>
                {/* {showAdminButtons ? (
                  <>
                    <BoldIconButton aria-label="delete product" bold>
                      <Delete />
                    </BoldIconButton>
                    <Typography>
                      &euro;{product.price}
                    </Typography>
                    <BoldIconButton aria-label="edit product" bold>
                      <Edit/>
                    </BoldIconButton>
                  </>
                ) : (
                  <>
                    <BoldIconButton aria-label="add to favorites" bold>
                      <FavoriteBorderSharpIcon />
                    </BoldIconButton>
                    <Typography>
                      &euro;{product.price}
                    </Typography>
                    <BoldIconButton aria-label="add to cart" bold>
                      <AddShoppingCart />
                    </BoldIconButton>
                  </>
                )} */}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
  </div>
  )
}

export default TestComponents